@use '../../../styles/variables' as *;
@use '../../../styles/mixins' as *;

// Shared overlay for all menu screens
.overlay {
  @include overlay;
}

// Settings gear button
.settingsBtn {
  position: absolute;
  top: $space-md;
  left: $space-md;
  background: transparent;
  border: 2px solid $color-secondary;
  border-radius: $radius-pill;
  font-size: $font-xl;
  width: 42px;
  height: 42px;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color $transition-fast;

  &:hover {
    border-color: $color-primary;
    transform: none;
    box-shadow: none;
  }
}

// Start screen
.controls {
  font-size: $font-sm;
  color: $color-text-dim;
  margin-bottom: $space-lg;
}

.version {
  position: absolute;
  bottom: 10px;
  right: $space-md;
  font-size: $font-xs;
  color: $color-text-dimmer;
  font-style: italic;
}

.versionLink {
  color: $color-text-dim;
  text-decoration: none;
  transition: color $transition-fast;

  &:hover {
    color: $color-gold;
    text-decoration: underline;
  }
}

// Pause menu
.pauseBtn {
  margin: 5px;
}

.quitBtn {
  @include gray-button;
}

// Menu leaderboard
.menuLeaderboardBtn {
  margin-top: $space-md;
  padding: 10px 25px;
  font-size: $font-md;
  background: transparent;
  border: 2px solid $color-secondary;
  color: $color-text-dim;

  &:hover {
    border-color: $color-primary;
    color: $color-text-white;
    box-shadow: none;
    transform: none;
  }
}

.menuLeaderboardClose {
  @include gray-button;
  padding: 12px 30px;
  font-size: $font-md;
}
